import EmergencyContactFormData from "./EmergencyContact";
import MailOtpFormData from "./MailOtp";
import ResetPasswordFormData from "./ResetPassword";
import SmartOtpFormData from "./SmartOtp";

const securityFormDataComponents = {
  EmergencyContactFormData,
  MailOtpFormData,
  ResetPasswordFormData,
  SmartOtpFormData
}

export default securityFormDataComponents